import { useCallback, useState } from 'react';

/** Counts of related records per tab, reported by each tab's panel once it has loaded. */
export function useTabCounts(): [Record<string, number>, (tabId: string, count: number) => void] {
  const [counts, setCounts] = useState<Record<string, number>>({});
  const report = useCallback((tabId: string, count: number) => {
    setCounts((previous) =>
      previous[tabId] === count ? previous : { ...previous, [tabId]: count },
    );
  }, []);
  return [counts, report];
}
